export default __webpack_public_path__ + "static/media/indexxTextLightMode.2522d76b.webp";